import React, { Component } from "react";
import { connect } from "react-redux";
import format from "date-fns/format";
import { DIMENSIONS } from "services/layoutManager";
import { Permissions } from "services/permissions";
import { validateAuthState } from "actions/auth";
import { ActionButton } from "styled_components/Common/ActionButton";
import { EditAvatar } from "styled_components/EditAvatar";
import { PortraitModalComponent } from "styled_components/Common/PortraitModalComponent";
import { AvatarApi } from "services/avatar";
import { SuccessMessage, ErrorMessage } from "utils/CommonConstants";
import { BloxButton } from "styled_components/Common/BloxButton";
import { UserDetails } from "styled_components/Account/UserDetails";
import { Settings } from "styled_components/Account/Settings";
import { JoyRideToolTip } from "styled_components/Common/JoyRideToolTip";
import Modal from "sub_components/Common/PortalModalNew";
import { UserApi, deleteUserProfile } from "services/user";
import {
  updateUser,
  resetUserUpdateStatus,
  updateUserAvatar,
} from "actions/user";
import {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
} from "actions/siteTracking";
import { MENU as PROFILE_MENU } from "utils/ProfileConstants";
import { SITE_PAGES, SITE_MODULES } from "utils/CommonConstants";
import BloxPage from "sub_components/Layout/BloxPage";
import UserInfo from "blox_components/Profile/UserContactSection/Components/UserInfo";
import ComponentWrapper from "sub_components/Layout/ComponentWrapper";
import ConfirmationModal from "sub_components/Common/ConfirmationModal";
import PasswordChange from "blox_components/Profile/PasswordChangeNew";
import { RESOLUTIONS } from "services/config";
import { setHomeTour } from "actions/tour";
import { updatePermissions } from "actions/permissions";
import { SERVICE_IDS } from "services/utils";
import { getUserPermissions, setUserPermissions } from "services/user";
import { ModalFooter } from "styled_components/Common/ModalFooter";
import { ModalHeader } from "styled_components/Common/ModalHeader";
import { MFAModalBody } from "styled_components/Account/MFAModalBody";
import Joyride from "react-joyride-react-19";

const CDN_URL = process.env.REACT_APP_CDN_URL;
const ForgotPasswordImage = `${CDN_URL}common/set-password-modal-icon.svg`;

const LAYOUT_CONFIG = {
  [RESOLUTIONS.LOW]: {
    userDetails: { x: 1, y: 4, dim: DIMENSIONS.TWO_BY_TEN },
    mainContent: { x: 1, y: 24, dim: DIMENSIONS.EIGHT_BY_TEN },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.MED]: {
    userDetails: { x: 1, y: 4, dim: DIMENSIONS.TWO_BY_EIGHT },
    mainContent: { x: 1, y: 32, dim: DIMENSIONS.EIGHT_BY_EIGHT },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.HIGH]: {
    userDetails: { x: 1, y: 4, dim: DIMENSIONS.TWO_BY_EIGHT },
    mainContent: { x: 1, y: 50, dim: DIMENSIONS.EIGHT_BY_EIGHT },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
};

class MyProfilePage extends Component {
  constructor(props) {
    super(props);
    this.avatarApi = new AvatarApi();
    this.state = {
      error: false,
      pages: null,
      selected: "user",
      selectedPage: null,
      seelctedPageValue: null,
      showAvatarModal: false,
      showActivationModal: false,
      openMFAModal: false,
      termsAccepted: false,
      mobileNumber: "",
      validNumber: false,
    };
  }
  setView = (view) => {
    const { updatePage, addPageToBreadCrumbs } = this.props;
    let selectedView = view;
    if (selectedView === "details") {
      selectedView = "My Profile";
    }
    updatePage(selectedView);
    addPageToBreadCrumbs(
      selectedView,
      SITE_MODULES.ACCOUNT,
      "/portal/account/my_profile",
      {
        selected: view,
      }
    );
  };

  componentDidMount() {
    const {
      updateModule,
      updatePage,
      addPageToBreadCrumbs,
      site,
      permissions,
      setHomeTour,
      location,
      selectedPageValue,
    } = this.props;
    const search = location?.search;

    updatePage(SITE_PAGES.PROFILE[PROFILE_MENU.MY_PROFILE]);
    addPageToBreadCrumbs(
      SITE_PAGES.PROFILE[PROFILE_MENU.MY_PROFILE],
      SITE_MODULES.ACCOUNT
    );
    if (
      location?.state?.selected &&
      selectedPageValue !== location?.state?.selected
    ) {
      this.setSelection(location?.state?.selected);
    }

    if (site?.module !== "ACCOUNT" || !permissions?.permissions) {
      this.getModulePages();
    }
    if (search.includes("tour=true")) {
      setHomeTour({ runHomeTour: true, action: "start" });
    }
    updateModule(SITE_MODULES.ACCOUNT);
  }
  componentDidUpdate() {
    const { selectedPageValue, selectedPage } = this.state;
    const { auth_status, permissions: pages, location } = this.props;
    if (!selectedPage && auth_status && pages?.permissions) {
      this.setSelection("details");
    }

    if (
      location?.state?.selected &&
      selectedPageValue !== location?.state?.selected
    ) {
      this.setSelection(location?.state?.selected);
    }
  }

  getModulePages = async () => {
    const {
      updatePermissions,
      auth_status: {
        user: { id: userId },
      },
      company_info: {
        customer: { id: orgId },
      },
    } = this.props;

    const permissions = getUserPermissions("account");
    if (!permissions) {
      const response = await Permissions.getModulePermissions(3, userId, orgId);
      if (response && !response.data.error) {
        setUserPermissions("account", response.data.pages);
        updatePermissions(response.data.pages);
      }
    } else {
      updatePermissions(permissions);
    }
  };

  renderHeader = (selectedAvatar) => {
    const header = (
      <div className="edit-avatar-header">
        <div className="image-section">
          <ActionButton className="small">
            <img src={selectedAvatar} data-cy="current-avatar" />
          </ActionButton>
        </div>

        <div className="avatar-description body10">
          Click the upload icon to add your image, or choose an avatar from our
          library below.
        </div>
      </div>
    );
    return header;
  };
  formatParams(params) {
    let formattedParams = {};
    if (params.job_title || params.job_title === "") {
      formattedParams = {
        userDetails: params,
      };
    } else if (params.phone_number === "(___) ___-____") {
      formattedParams = {
        contactDetails: { phone_number: "" },
      };
    } else if (params.mobile_number === "(___) ___-____") {
      formattedParams = {
        contactDetails: { mobile_number: "" },
      };
    } else {
      formattedParams = {
        contactDetails: params,
      };
    }

    return formattedParams;
  }
  toggleAvatarModal = () => {
    const { showAvatarModal } = this.state;
    this.setSelection("avatar");
    this.setState({ showAvatarModal: !showAvatarModal });
  };
  toggleMFAModal = () => {
    this.setState({ openMFAModal: false, validNumber: false });
  };
  toggleActivationModal = () => {
    const { showActivationModal } = this.state;
    this.setState({ showActivationModal: !showActivationModal });
  };
  updateUser = (params) => {
    const { updateUser } = this.props;
    const formattedParams = this.formatParams(params);
    let response = "";
    if (Object.keys(formattedParams).length > 0) {
      response = updateUser(formattedParams);
      return response;
    }
  };
  cancelActivation = () => {
    const cancelButton = document.getElementById("cancel-button-swipe");

    if (cancelButton) {
      cancelButton.classList.add("active");
    }
    setTimeout(() => {
      this.toggleActivationModal();
    }, 2000);
  };

  getSettingSelections = () => {
    return [
      {
        label: "Edit Details",
        value: "details",
      },
      {
        label: "Avatar",
        value: "avatar",
      },
      {
        label: "Security",
        value: "security",
      },
    ];
  };
  getHeaderSelections = () => {
    const { permissions: pages } = this.props;
    const hasChangePasswordAccess = Permissions.checkComponentAccess(
      pages,
      "My Profile",
      "change-password"
    );
    const hasEditAvatarAccess = Permissions.checkComponentAccess(
      pages,
      "My Profile",
      "edit-avatar"
    );

    const selections = [
      {
        label: "Edit Details",
        value: "details",
      },
    ];

    if (hasEditAvatarAccess) {
      selections.push({
        label: "Avatar",
        value: "avatar",
      });
    }

    if (hasChangePasswordAccess) {
      selections.push({ label: "Security", value: "security" });
    }

    return selections;
  };
  setSelectedAvatar = (selectedAvatar) => {
    this.setState({ selectedAvatar });
  };

  openMFAModal = () => {
    this.setState({ openMFAModal: true });
  };

  setSelection = (selection) => {
    const {
      auth_status,
      permissions: pages,
      breakpoint,
      setModalContent,
      auth_status: { user },
      navigate,
    } = this.props;
    let selectedPage = "";
    navigate("/portal/account/my_profile");
    const profileImage = user?.userProfile
      ? this.avatarApi.getUserAvatar(user)
      : this.avatarApi.getGenericAvatar();

    switch (selection) {
      case "avatar":
        this.setView("avatar");
        selectedPage = (
          <div className="avatar-display">
            <div className="image">
              <img src={profileImage} />
            </div>
            <BloxButton
              id="button-1"
              text="EDIT"
              module="account"
              enabled={true}
              className=" avatar-button buttons41"
              onClick={this.toggleAvatarModal}
              cypressId="edit-avatar"
            />
          </div>
        );
        break;
      case "security":
        this.setView("security");
        selectedPage = (
          <PasswordChange
            openMFAModal={this.openMFAModal}
            setModalContent={setModalContent}
            setView={this.setSelection}
          />
        );
        break;
      case "details":
        this.setView("details");
        selectedPage = (
          <UserInfo
            updateUser={this.updateUser}
            profile={auth_status?.user}
            updateStatus={auth_status?.type}
            pages={pages}
            breakpoint={breakpoint}
          />
        );
        break;
      default:
        selectedPage = (
          <UserInfo
            updateUser={this.updateUser}
            profile={auth_status?.user}
            updateStatus={auth_status?.type}
            pages={pages}
            breakpoint={breakpoint}
          />
        );
    }
    this.setState({ selectedPage, selectedPageValue: selection });
  };

  getUsersRole = (id) => {
    const { auth_status } = this.props;
    const { memberships = {} } = auth_status;
    const currentMembershipSelected = memberships.filter(
      (membership) => Number(membership.organizationId) === Number(id)
    );

    return currentMembershipSelected[0]?.role;
  };
  getFields = () => {
    const {
      auth_status: { user },
      company_info,
    } = this.props;

    const email = user?.contactDetails?.email;
    let lastLogin = user?.lastLogin;
    if (lastLogin) {
      lastLogin = format(new Date(lastLogin), "MM / dd / yy");
    }
    return {
      type: "horizontal",
      top: [
        { label: "Email", value: email },
        { label: company_info?.customer?.companyName, value: "" },
      ],
      bottom: [
        { label: "Role", value: this.getUsersRole(company_info?.customer?.id) },
        { label: "Last Login", value: lastLogin },
      ],
    };
  };
  getSize = (breakpoint) => {
    let size = "large";
    if (breakpoint === RESOLUTIONS.MED) {
      size = "medium";
    } else if (breakpoint === RESOLUTIONS.HIGH) {
      size = "medium";
    }

    return size;
  };
  closeTour = (joyride) => {
    const { setHomeTour } = this.props;

    const action = joyride?.action;

    if (action === "close" || action === "reset" || action === "stop") {
      setHomeTour({ runHomeTour: false, action });
    }
  };

  goToNextModule = () => {
    const { location, navigate } = this.props;
    const moduleOrder = location?.state?.moduleOrder;

    if (moduleOrder && moduleOrder.length !== 0) {
      const nextIndex = moduleOrder[0];

      if (nextIndex) {
        const nextModule = SERVICE_IDS[nextIndex];
        const url = `/portal`;
        navigate(url, { state: { nextModule, moduleOrder } });
      }
    }
  };

  hasNextModule = () => {
    const { location } = this.props;
    const moduleOrder = location?.state?.moduleOrder;

    if (moduleOrder && moduleOrder.length !== 0) {
      const nextIndex = moduleOrder[0];

      if (!nextIndex) {
        return null;
      } else {
        return (
          <BloxButton
            className="buttons41"
            id="continue-tour"
            text="CONTINUE"
            module="account"
            enabled={true}
            onClick={this.goToNextModule}
            cypressId="continue-tour"
          />
        );
      }
    }
  };

  checkUserManagementPermission = (permissions) => {
    const pages = permissions?.permissions;
    let hasAccess = false;
    if (!pages) {
      return hasAccess;
    }
    for (let i = 0; i <= pages.length - 1; i++) {
      if (
        pages[i].permissions > 0 &&
        pages[i].displayName === "Account Management"
      ) {
        hasAccess = true;
      }
    }
    return hasAccess;
  };

  onChange = (e) => {
    let number = e.target.value;
    number = number.match(/\d/g);
    number = number.join("");

    if (number.length === 10) {
      this.setState({ validNumber: true, mobileNumber: e.target.value });
    } else {
      this.setState({ validNumber: false, mobileNumber: e.target.value });
    }
  };

  updateNumber = () => {
    const { mobileNumber } = this.state;
    this.setState({ validNumber: false, mobileNumber: "" });
    this.toggleMFAModal();
    this.updateUser({ mobile_number: mobileNumber });
    this.updateUserProfile("SMS");
  };

  removeUserProfile = () => {
    const { validateAuthState } = this.props;
    deleteUserProfile();
    validateAuthState();
  };

  updateUserProfile = (mfaMethod) => {
    const { setModalContent } = this.props;
    const params = {
      mfaMethod,
    };
    const button = (
      <BloxButton
        className="buttons41"
        id="okay"
        text="OKAY"
        module="account"
        enabled={true}
        onClick={() => {}}
        cypressId="okay"
      />
    );
    UserApi.updateMFA(params)
      .then((response) => {
        if (response && !response.data.error) {
          setModalContent("TIMEOUT_CLOSE", SuccessMessage, button);
          this.removeUserProfile();
        } else {
          setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
        }
      })
      .catch(() => {
        setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
      });
  };

  removeMFA = () => {
    const { setModalContent } = this.props;
    const params = {
      mfaMethod: "Email",
    };
    this.toggleMFAModal();
    const button = (
      <BloxButton
        className="buttons41"
        id="okay"
        text="OKAY"
        module="account"
        enabled={true}
        onClick={() => {}}
        cypressId="okay"
      />
    );
    UserApi.updateMFA(params)
      .then((response) => {
        if (response && !response.data.error) {
          setModalContent("TIMEOUT_CLOSE", SuccessMessage, button);
          this.removeUserProfile();
        } else {
          setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
        }
      })
      .catch((e) => {
        console.log(e);
        setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
      });
  };

  render() {
    const {
      showAvatarModal,
      showActivationModal,
      selectedPage,
      selectedPageValue,
      selectedAvatar,
      openMFAModal,
      validNumber,
    } = this.state;

    const {
      breakpoint,
      location,
      permissions: pages,
      setModalContent,
      updateUserAvatar,
      tour: { runHomeTour: { runHomeTour } } = {},
      auth_status: { user },
      auth_status: {
        user: { firstname = {}, lastname = {}, contactDetails = {} },
      } = {},
      auth_status,
      site,
      navigate,
    } = this.props;
    const secondFactorMethod = user?.userProfile?.secondFactorMethod;
    const profileImage = user?.userProfile
      ? this.avatarApi.getUserAvatar(user)
      : this.avatarApi.getGenericAvatar();

    const pendingText = !JSON.parse(user?.enabled) ? "activate" : "deactivate";
    const usersName = user ? `${user?.firstname} ${user?.lastname}` : "";
    const module = site?.module;
    const moduleOrder = location?.state?.moduleOrder;
    const hasUserManagementAccess = this.checkUserManagementPermission(pages);
    const finishTour =
      !hasUserManagementAccess && !this.hasNextModule() ? true : false;
    const nextButton = hasUserManagementAccess ? (
      <BloxButton
        className="buttons41"
        id="continue-tour"
        text="Continue"
        module="account"
        enabled={true}
        onClick={() =>
          navigate("/portal/account/account_management?tour=true", {
            state: { moduleOrder },
          })
        }
        cypressId="continue-tour"
      />
    ) : (
      this.hasNextModule()
    );
    const steps = [
      {
        target: "#header-selection-0",
        module: "account",
        disableBeacon: true,
        content:
          "On the first tab here, you can edit your account details. Did you know that if you add your cell phone to your profile, I can send your login token as an SMS to your phone? Let’s move on…",
      },
      {
        target: "#header-selection-1",
        module: "account",
        content:
          "Finally! Your avatar. On this second tab, you can either select an avatar available to you, or you can upload a picture of your own choosing.",
      },
      {
        target: "#header-selection-2",

        module: "account",
        content:
          "Managing your password is very important, and if you ever need to change it, this is the location to do so.",
        customNextButton: !finishTour ? nextButton : null,
        locale: { next: "Finish" },
      },
    ];

    return (
      <BloxPage
        name="page my-profile-page"
        layout={LAYOUT_CONFIG[breakpoint]}
        breakpoint={breakpoint}
        location={location}
        setModalContent={setModalContent}
      >
        <div key={`tourButton`} className="tourButton">
          {pages && (
            <Joyride
              steps={steps}
              continuous={true}
              tooltipComponent={JoyRideToolTip}
              run={runHomeTour}
              styles={{
                options: {
                  zIndex: 5000,
                },
              }}
              module={module}
              callback={this.closeTour}
              spotlightPadding={5}
              disableScrolling={true}
              disableBeacon={true}
              disableOverlayClose={true}
            />
          )}
        </div>
        <div key={`userDetails`} className="userDetails">
          <ComponentWrapper title={usersName} hideBorder>
            <UserDetails
              image={profileImage}
              user={user}
              fields={this.getFields()}
              selectedToggle="portal"
              editRole={false}
            />
          </ComponentWrapper>

          {showActivationModal && (
            <Modal>
              <ConfirmationModal
                title={"ARE you sure ? "}
                text={`Please confirm you want to ${pendingText} ${firstname} ${lastname} for this site.`}
                onAccept={() =>
                  this.onAccept(contactDetails.id, !JSON.parse(user?.enabled))
                }
                onCancel={this.cancelActivation}
                enabled={showActivationModal}
              />
            </Modal>
          )}
        </div>
        <div key={`mainContent`} className="mainContent">
          <ComponentWrapper title="Settings" hideBorder>
            <Settings
              onSelectionClick={this.setSelection}
              onHeaderClick={this.setSelection}
              settingSelections={this.getSettingSelections()}
              headerSelections={this.getHeaderSelections()}
              selectedPage={selectedPage}
              selectedPageValue={selectedPageValue}
              includeSelection={false}
            />
            <PortraitModalComponent
              closeModal={this.toggleAvatarModal}
              show={showAvatarModal}
              header={this.renderHeader(selectedAvatar)}
              title="My Avatar"
              subTitle="Avatar Library"
              size={this.getSize(breakpoint)}
              customClassName="no-padding"
              breakpoint={breakpoint}
            >
              <EditAvatar
                closeModal={this.toggleAvatarModal}
                currentAvatar={profileImage}
                updateUserAvatar={updateUserAvatar}
                auth_status={auth_status}
                callback={this.setSelectedAvatar}
                setModalContent={setModalContent}
              />
            </PortraitModalComponent>
            <PortraitModalComponent
              closeModal={this.toggleMFAModal}
              show={openMFAModal}
              header={
                <ModalHeader
                  image={ForgotPasswordImage}
                  text={""}
                  className="forgot-password"
                />
              }
              subTitle={"MFA through SMS "}
              title="MFA"
              size={this.getSize(breakpoint)}
              breakpoint={breakpoint}
            >
              <MFAModalBody
                text={
                  secondFactorMethod === "SMS"
                    ? `To remove MFA through SMS please click " REMOVE " `
                    : `To enable MFA through SMS please enter your mobile number :`
                }
                onChange={this.onChange}
              />
              <ModalFooter
                cypressId="footer"
                id="footer"
                buttonText1={secondFactorMethod === "SMS" ? "Remove" : "Accept"}
                buttonText2="Back"
                buttonActive1={validNumber || secondFactorMethod === "SMS"}
                buttonActive2={true}
                module="account"
                buttonFunction1={
                  secondFactorMethod === "SMS"
                    ? this.removeMFA
                    : this.updateNumber
                }
                size={this.getSize(breakpoint)}
                buttonFunction2={this.toggleMFAModal}
              />
            </PortraitModalComponent>
          </ComponentWrapper>
        </div>
      </BloxPage>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    company_info: state.company_info,
    theme: state.theme,
    site: state.site_tracking,
    permissions: state.permissions,
    tour: state.tours,
  };
}

export default connect(mapStateToProps, {
  updateUser,
  resetUserUpdateStatus,
  updatePage,
  updateModule,
  addPageToBreadCrumbs,
  updateUserAvatar,
  updatePermissions,
  validateAuthState,
  setHomeTour,
})(MyProfilePage);
